import { chain } from 'radash';
import { PrismicContentSerializer } from '@monofront/types';

export const chainPrismicContentSerializers =
  (...serializers: PrismicContentSerializer[]) =>
  (text: string) =>
    chain(...serializers)(text);
